import { render, staticRenderFns } from "./themeHeader.vue?vue&type=template&id=bc3639a8&scoped=true"
import script from "./themeHeader.vue?vue&type=script&lang=js"
export * from "./themeHeader.vue?vue&type=script&lang=js"
import style0 from "./themeHeader.vue?vue&type=style&index=0&id=bc3639a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3639a8",
  null
  
)

export default component.exports